import { FC, forwardRef, useMemo } from 'react';
import { IoPerson } from 'react-icons/io5';
import { Skeleton } from '@mui/material';
import { ProfileImgPropTypes } from './types/propsType';
import styles from './ProfileImage.module.scss';

const colorSet = [
  '#6d8e95',
  '#d69e9e',
  '#e4bcba',
  '#cfaa74',
  '#fbd9a7',
  '#c8cd97',
  '#ca7f7f',
  '#b7aa6a',
  '#5291b1',
  '#7b7d80',
];

const ProfileImage: FC<ProfileImgPropTypes> = forwardRef<HTMLDivElement, ProfileImgPropTypes>(
  ({ placeholder, classes = '', src, isLoading = false, onClick }, ref) => { // Add onClick prop
    const getValue = useMemo(() => {
      let letter = '';
      let words = placeholder.split(' ');
      if (words.length > 1) letter = words[0]?.[0] + words.pop()?.[0];
      else letter = words[0].substring(0, 2);
      return {
        placeholder: letter.toUpperCase(),
        backgroundColor: colorSet[placeholder.length % colorSet.length],
      };
    }, [placeholder]);

    return (
      <div style={{ height: 'fit-content' }}>
        <div className={`${styles['profile']} ${classes}`.trim()} data-testid="profile-image" ref={ref} onClick={onClick}> {/* Add onClick here */}
          <div
            className={`${styles['profile-container']} ${
              src ? styles['profile-container--picture'] : styles['profile-container--text']
            }`.trim()}
            style={!isLoading && !src ? { backgroundColor: getValue.backgroundColor } : {}}
          >
            {isLoading ? (
              <Skeleton variant="circular" />
            ) : src ? (
              <picture>
                <img src={src} alt={placeholder} loading="lazy" />
              </picture>
            ) : (
              <div
                className={`${styles['profile-placeholder']} ${
                  !placeholder ? styles['profile-placeholder-icon'] : ''
                }`.trim()}
              >
                {getValue.placeholder || <IoPerson />}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  },
);

export default ProfileImage;
